import React from 'react';
import styled from 'styled-components';

const BannerBackground = (props) => {
  const { children } = props;

  return (
    <Wrapper>
      <Container>{children}</Container>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  background: var(--blue-dark);
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='2000px' height='392px' viewBox='0 0 2000 392' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3Ebanner-wave%3C/title%3E%3Cg id='Pages---Home-&amp;-Solutions' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' opacity='0.1'%3E%3Cg id='Banner' transform='translate(0, -523)' fill='%231030AE'%3E%3Cpath d='M0.5,914.752809 C-0.166666667,872.086142 -0.166666667,797.086142 0.5,689.752809 C1026.06154,522.294736 1693.06154,480.961403 2001.5,565.752809 C2001.42532,565.752809 2001.42532,682.086142 2001.5,914.752809 C667.369324,914.746781 0.369324499,914.746781 0.5,914.752809 Z' id='banner-wave'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: 100%;
  padding: 125px 20px 75px;
  ${({ theme }) => `
    @media ${theme.smallUp} {
      padding: 95px 50px 75px;
    }
    @media ${theme.mediumUp} {
      padding: 100px 50px 75px;
    }
    @media ${theme.largeUp} {
        padding: 100px 50px 140px;
    }
`}
`;

const Container = styled.div`
  max-width: 1700px;
  margin: auto;
`;

export default BannerBackground;
